import React from "react";
import ExperienceItem from "./ExperienceItem";

const Experience = () => {
  const data = [
    {
      id: 1,
      duration: "July 2020 - Present",
      title: "Software Engineering Lead",
      name: "Haven Technologies, Boston",
      details: "",
    },
    {
      id: 2,
      duration: "August 2018 - July 2020",
      title: "Senior Software Engineer",
      name: "Haven Technologies, Boston",
      details: "",
    },
    {
      id: 4,
      duration: "July 2017 - August 2018",
      title: "Software Engineer",
      name: "Quilt Inc, Boston",
      details: "",
    },
    {
      id: 4,
      duration: "January 2016 - August 2016",
      title: "Software Developer Intern",
      name: "New York Life R&D Labs, New York",
      details: "",
    },
    {
      id: 5,
      duration: "May 2011 - December 2014",
      title: "Project Lead",
      name: "Oracle, India",
      details: "",
    },
    {
      id: 6,
      duration: "November 2007 - April 2011",
      title: "Senior Systems Engineer",
      name: "Infosys, India",
      details: "",
    },
  ];

  return (
    <div
      name="experience"
      className="h-auto w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-lg p-4 mx-auto my-auto flex flex-col justify-cent w-full h-full pt-20">
        <div className="pb-4 pt-5">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500 text-white">
            Experience
          </p>
        </div>
        <div className="pt-4 mt-10">
          <p className="text-xl mt-5 inline border-b-4  border-gray-500 text-white">
            {data.map((item, id) => (
              <ExperienceItem
                key={id}
                title={item.title}
                duration={item.duration}
                name={item.name}
                details={item.details}
              />
            ))}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Experience;
